import BaseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import store from '../../redux';
import { AUTOCOMPLETE_STATUS, setAutocompleteResults, setAutocompleteStatus } from '../../redux/actions/actions_data';

class AutocompleteRequest extends BaseRequest {
  constructor(onAnyResponse, signal) {
    super();
    this.dispatch = null;
    this.response = null;
    this.name = 'Autocomplete Request';
    this.config = new AppConfig();
    this.onAnyResponse = onAnyResponse;
    this.signal = signal;
  }

  // AB testing removed — full rollout to search service (`autocomplete/benefits`). Previous implementation: git history of this file.
  execute(dispatch, query) {
    this.dispatch = dispatch;
    this.dispatch(setAutocompleteStatus(AUTOCOMPLETE_STATUS.LOADING));

    const { apiPath } = store.getState().config.Parameters.searchConfiguration;
    const url = `${apiPath.replace(/\/$/, '')}/autocomplete/benefits?query=${encodeURIComponent(query)}`;

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: { 'x-xsrf-token': '1' },
      signal: this.signal,
    })
      .then((response) => response.json().then((json) => ({ response, json })))
      .then(({ response, json }) => {
        this.response = json;
        if (!response.ok || json.statusCode >= 400) {
          this.onFailure();
          return;
        }
        this.onSuccess();
      })
      .catch((error) => this.handleServerError(error));
  }

  onSuccess() {
    const data = Array.isArray(this.response.data) ? this.response.data : [];
    this.updateState(data);
    this.dispatch(setAutocompleteStatus(
      data.length > 0 ? AUTOCOMPLETE_STATUS.RESULTS : AUTOCOMPLETE_STATUS.NO_RESULTS,
    ));
    this.onAnyResponse();
  }

  onFailure() {
    this.dispatch(setAutocompleteStatus(AUTOCOMPLETE_STATUS.ERROR));
    this.onAnyResponse();
  }

  handleServerError(error) {
    if (error.name === 'AbortError') return;
    this.dispatch(setAutocompleteStatus(AUTOCOMPLETE_STATUS.ERROR));
    this.onAnyResponse();
  }

  updateState(data) {
    this.dispatch(setAutocompleteResults(data));
  }
}

export default AutocompleteRequest;
